/**
 * FactorySummaryMap — dispatcher chọn component "Sơ đồ Kho" theo factory.
 *
 * Mỗi nhà máy có sơ đồ kho thật khác nhau (BL.A/B/C cho Bảo Lộc, các factory
 * khác sẽ có grid riêng) → component riêng cho từng factory, đăng ký vào
 * `MAP_BY_FACTORY`. Factory chưa có sơ đồ → fallback `GenericSummaryMap`
 * (render dạng bảng từ `mapCells`).
 *
 * Phần còn lại của summary panel (allocation rows, quality, category) dùng
 * chung UI — không phụ thuộc factory.
 */
import type { ComponentType } from 'react'
import { FactoryBaoLocSummaryMap } from '../baoLoc/FactoryBaoLocSummaryMap'
import { NhonTrachSummaryMap } from './NhonTrachSummaryMap'
import GenericSummaryMap from './GenericSummaryMap'
import type { FactoryCell } from '@/store/api/factoryApi'
import type { FactorySummaryMapCell } from '../baoLoc/FactoryBaoLocSummaryMap'

interface SummaryMapProps {
  mapCells: FactorySummaryMapCell[]
  sumRow?: Record<string, FactoryCell> | null
  kvSx?: number | null
  scope?: 'all' | 'kho-a' | 'kho-bc' | 'allocation'
  title?: string
  subtitle?: string
  factoryName?: string
}

/** Registry: factory_code → component sơ đồ kho riêng của nhà máy đó. */
const MAP_BY_FACTORY: Record<string, ComponentType<SummaryMapProps>> = {
  baoloc: FactoryBaoLocSummaryMap,
  nhontrach: NhonTrachSummaryMap,
  // nguyencuong: AnPhuocSummaryMap,    // TODO khi có layout
  // nongsan:     NongSanSummaryMap,    // TODO
  // pacorini:    PacoriniSummaryMap,   // TODO
}

interface Props extends SummaryMapProps {
  factoryCode: string
}

export function FactorySummaryMap({ factoryCode, ...rest }: Props) {
  const Component = MAP_BY_FACTORY[factoryCode] ?? GenericSummaryMap
  return <Component {...rest} />
}
